<app-protected-content [requiredRoles]="requiredRoles">
  @let columns = (columnConfig$ | async) || [];
  @let tabList = tabs$ | async;
  @if (tabList === null) {
    <htx-skeleton width="30%" height="2rem" borderRadius="6px"></htx-skeleton>
    <htx-skeleton width="100%" height="2.5rem" borderRadius="6px"></htx-skeleton>
    <htx-skeleton
      width="100%"
      height="2.75rem"
      [lines]="5"
      gap="0.25rem"
      borderRadius="4px"
    ></htx-skeleton>
  } @else {
    <htx-tabs [tabs]="tabList" variant="minimal" (tabChanged)="onTabChanged($event)">
      @if (activeTabId() === 'pending') {
        @let pendingData = pendingRequests$ | async;
        <htx-table
          [data]="pendingData ?? []"
          [loading]="pendingData === null"
          [columns]="columns"
          emptyMessage="request.overview.noPendingRequests"
        ></htx-table>
      }

      @if (activeTabId() === 'processed') {
        @let processedData = processedRequests$ | async;
        <htx-table
          [data]="processedData ?? []"
          [loading]="processedData === null"
          [columns]="columns"
          emptyMessage="request.overview.noProcessedRequests"
        ></htx-table>
      }
    </htx-tabs>
  }

  <ng-template #columnType let-row>
    @let item = getTyped(row);
    <htx-badge
      [text]="
        item.type === 'organization'
          ? ('request.type.organization' | transloco)
          : item.type === 'usecase'
            ? ('request.type.usecase' | transloco)
            : ('request.type.representativeChange' | transloco)
      "
      [variant]="
        item.type === 'organization'
          ? 'primary'
          : item.type === 'usecase'
            ? 'secondary'
            : 'tertiary'
      "
    >
    </htx-badge>
  </ng-template>

  <ng-template #columnStatus let-row>
    @let item = getTyped(row);
    @let status = item.admissionState;
    <htx-badge
      [text]="'organization.control.admissionState.options.' + status | transloco"
      [variant]="
        status === AdmissionState.PENDING
          ? 'warning'
          : status === AdmissionState.APPROVED
            ? 'success'
            : status === AdmissionState.SUSPENDED
              ? 'info'
              : 'danger'
      "
    >
    </htx-badge>
  </ng-template>

  <ng-template #columnActions let-row>
    @let item = getTyped(row);
    <div class="action-buttons">
      <htx-button
        variant="tertiary"
        icon="visibility"
        [iconOnly]="true"
        tooltip="Prüfen"
        (click)="goToDetail(item)"
      ></htx-button>
    </div>
  </ng-template>
</app-protected-content>
